/* ============================================================
   INDIGREY — wayfinding
   ------------------------------------------------------------
   The catalogue is reachable from several directions, but every horizontal
   strip and every grid used to end in a wall. This layer turns those endings
   into doors, and — just as importantly — makes coming BACK from a product
   land you exactly where you left off.

   Five jobs:

   1. VIEW-ALL TARGETS. The homepage strips are hand-curated (nine and ten
      pieces). That curation is deliberate and stays. What was wrong is that
      their "View All" led into the curated set itself — a shopper asking to
      see everything landed on nine pieces. New Arrivals now opens the full
      catalogue newest-first, Best Sellers opens it best-selling-first: the
      button continues the thought the strip started.

   2. A WAY OUT OF EVERY FINITE STRIP — cart recommendations, empty wishlist,
      empty search. Each gets the site's own solid button, always inside a
      wrapper div: appended bare, the anchor could match the base theme's
      `.shopify-section:first-child > :first-of-type` page-spacing rule and
      inherit 40px of top padding, which is what made the cart button tower
      over everything around it.

   3. END OF THE GRID. One button onward, no copy. A line such as "that's all
      N pieces" would announce the size of the catalogue to every shopper,
      which is not ours to give away.

   4. RETURN-TO-PLACE. Paginating the grid (see ig-mobile-perf.js) means back
      from a product would otherwise drop you at the top with twelve items.
      Where the browser's back/forward cache does the job we never run at all;
      this is the safety net for when it does not. The position is remembered
      by PRODUCT HANDLE rather than by pixel offset, because content-visibility
      means offsets are estimates until a card has been rendered once — an
      anchor survives that, a y-coordinate does not.

   5. THE PDP BACK LINK. It pointed at product.collections.first, which is
      whichever collection Shopify happens to list first — often not the one
      the shopper came from. It now points where they actually were.
   ============================================================ */
(function () {
  'use strict';

  var ALL = '/collections/shop';            /* everything, best-selling first */
  var NEW = '/collections/new-arrivals';    /* everything, newest first       */

  function esc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }
  function body() { return document.body || document.documentElement; }
  function surface(name) { return body().classList.contains('ig-rd-surface-' + name); }

  /* ----------------------------------------------------------
     1. VIEW-ALL TARGETS
     Only links whose visible text IS a view-all label are retargeted, so the
     navigation menu's own links to these collections are left alone.
     ---------------------------------------------------------- */
  var RETARGET = {};
  RETARGET['/collections/new-arrivals-2'] = NEW;
  RETARGET['/collections/best-sellers'] = ALL;

  function retargetViewAll(root) {
    (root || document).querySelectorAll('a[href]').forEach(function (a) {
      var label = (a.textContent || '').trim().toLowerCase();
      if (!/^(view all|view more|shop all|see all)\b/.test(label)) return;
      var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      if (RETARGET[href]) a.setAttribute('href', RETARGET[href]);
    });
  }

  /* ----------------------------------------------------------
     2. A WAY OUT OF FINITE STRIPS
     ---------------------------------------------------------- */
  function wayOut(href, label) {
    var a = document.createElement('a');
    a.className = 'ig-rd-viewall';
    a.setAttribute('href', href);
    var s = document.createElement('span');
    s.className = 'ig-rd-viewall__label';
    s.textContent = label;
    a.appendChild(s);
    return a;
  }
  /* Always wrapped — see the note in the header about the page-spacing rule. */
  function appendWayOut(host, href, label) {
    if (!host || host.querySelector('.ig-rd-viewall')) return;
    var box = document.createElement('div');
    box.className = 'ig-rd-wayout';
    box.appendChild(wayOut(href, label));
    host.appendChild(box);
  }

  function stripsAndEmptyStates() {
    /* cart: the saved-pieces strip is the natural "keep shopping" moment */
    if (surface('cart')) {
      var card = document.querySelector('.ig-rd-card');
      if (card) appendWayOut(card.closest('.shopify-section') || card.parentElement, ALL, 'View more');
    }
    /* empty wishlist and empty search were both dead ends */
    if ((surface('wishlist') || surface('search')) && !document.querySelector('.ig-rd-card')) {
      appendWayOut(document.getElementById('MainContent'), NEW, 'Browse the collection');
    }
  }

  /* ----------------------------------------------------------
     3. END OF THE GRID
     Only once the load-more control has retired — i.e. there is genuinely
     nothing left to load. Button only, and no label anywhere names a count.
     ---------------------------------------------------------- */
  function endcap() {
    var grid = document.querySelector('.ig-rd-grid');
    if (!grid) return;
    var existing = document.querySelector('.ig-rd-endcap');
    if (document.querySelector('.ig-rd-more__btn')) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }
    if (existing) return;
    if (!grid.querySelector('.ig-rd-card')) return;   /* empty collection has its own copy */

    var here = location.pathname.replace(/\/$/, '');

    /* The same catalogue read the other way round — named by its ORDER, not by
       the curated Best Sellers collection, which is a different, smaller thing. */
    var onward;
    if (here === NEW)      onward = { href: ALL, label: 'See best selling first' };
    else if (here === ALL) onward = { href: NEW, label: 'See newest first' };
    else                   onward = { href: ALL, label: 'View more' };

    var wrap = document.createElement('div');
    wrap.className = 'ig-rd-endcap';
    var links = document.createElement('div');
    links.className = 'ig-rd-endcap__links';
    links.appendChild(wayOut(onward.href, onward.label));
    wrap.appendChild(links);

    var anchorEl = document.querySelector('.ig-rd-pagination') || grid;
    anchorEl.parentNode.insertBefore(wrap, anchorEl.nextSibling);
  }

  /* ----------------------------------------------------------
     4. RETURN-TO-PLACE
     ---------------------------------------------------------- */
  var GRID_KEY = 'ig:grid';
  var COL_KEY = 'ig:lastcol';

  function store(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  function currentPage() {
    var cur = document.querySelector('.pagination__item--current');
    var n = cur ? parseInt(cur.textContent.trim(), 10) : 1;
    return isNaN(n) ? 1 : n;
  }
  /* The topmost card still touching the viewport, and how far above the fold
     its top sits — enough to put the shopper back on the same row. */
  function viewportAnchor() {
    var cards = document.querySelectorAll('.ig-rd-grid .ig-rd-card');
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      if (r.bottom > 0) {
        return { handle: cards[i].getAttribute('data-product-handle'), offset: Math.round(r.top) };
      }
    }
    return null;
  }
  function saveGrid() {
    if (!document.querySelector('.ig-rd-grid')) return;
    var a = viewportAnchor();
    store(GRID_KEY, JSON.stringify({
      url: location.pathname + location.search,
      page: currentPage(),
      y: Math.round(window.scrollY || 0),
      handle: a && a.handle,
      offset: a ? a.offset : 0,
      t: Date.now()
    }));
  }

  function restoreGrid() {
    var raw = read(GRID_KEY);
    if (!raw) return;
    var s;
    try { s = JSON.parse(raw); } catch (e) { return; }
    if (!s || s.url !== location.pathname + location.search) return;
    if (Date.now() - s.t > 30 * 60 * 1000) return;            /* stale — treat as a fresh visit */
    if (s.page <= 1 && !s.handle) return;

    /* Returning from a product is the signal we want. An empty referrer is
       common enough (privacy settings, in-app browsers, some iOS cases) that it
       is treated as unknown rather than as a refusal. But a referrer that IS
       present and is clearly somewhere else — the homepage, the menu, another
       collection — means the shopper is starting fresh, and throwing them
       thirty products down the page would be worse than doing nothing. */
    var ref = document.referrer || '';
    if (ref && !/\/products\//.test(ref)) return;

    /* Take scroll control away from the browser only for this restore, then
       hand it straight back — leaving it on 'manual' would break normal
       back-navigation everywhere else. */
    var hadAuto = false;
    if ('scrollRestoration' in history && history.scrollRestoration === 'auto') {
      history.scrollRestoration = 'manual';
      hadAuto = true;
    }
    function release() { if (hadAuto) history.scrollRestoration = 'auto'; }

    var guard = 0;
    (function step() {
      if (currentPage() >= s.page || guard++ > 12) { land(); return; }
      var btn = document.querySelector('.ig-rd-more__btn');
      if (!btn) { land(); return; }
      btn.click();
      setTimeout(step, 450);
    })();

    function land() {
      settle();
      /* content-visibility means a card's height is an estimate until it has
         been rendered once, so the first landing can be a little off. A
         second pass after the browser has laid the row out lands it exactly. */
      setTimeout(settle, 260);
      setTimeout(function () { settle(); release(); }, 700);
    }
    function settle() {
      var el = s.handle && document.querySelector('.ig-rd-card[data-product-handle="' + esc(s.handle) + '"]');
      if (el) {
        var y = el.getBoundingClientRect().top + (window.scrollY || 0) - (s.offset || 0);
        window.scrollTo(0, Math.max(0, Math.round(y)));
      } else if (s.y) {
        window.scrollTo(0, s.y);
      }
    }
  }

  /* ----------------------------------------------------------
     5. THE PDP BACK LINK
     ---------------------------------------------------------- */
  function rememberCollection() {
    if (document.querySelector('.ig-rd-grid')) store(COL_KEY, location.pathname + location.search);
  }
  function retargetBack() {
    var back = document.querySelector('[data-ig-back]');
    if (!back) return;
    var last = read(COL_KEY);
    if (last) back.setAttribute('href', last);
  }

  /* ---------------------------------------------------------- */
  function boot() {
    retargetViewAll(document);
    stripsAndEmptyStates();
    rememberCollection();
    retargetBack();
    endcap();
    restoreGrid();
  }

  /* Leaving for a product: remember the place. Captured on the way down so it
     runs before the card's own navigation handler. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.ig-rd-card')) saveGrid();
  }, true);
  window.addEventListener('pagehide', saveGrid);

  /* the grid re-renders on filter/sort and grows on load-more */
  document.addEventListener('ig-rd:grid-updated', function () {
    setTimeout(function () { retargetViewAll(document); endcap(); }, 0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
